import { render } from "./RoomSelectArea.vue?vue&type=template&id=ecbc34d8&scoped=true&ts=true"
import script from "./RoomSelectArea.vue?vue&type=script&lang=ts"
export * from "./RoomSelectArea.vue?vue&type=script&lang=ts"

import "./RoomSelectArea.vue?vue&type=style&index=0&id=ecbc34d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecbc34d8"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QInput,QBtn,QDialog,QCard,QIcon});
